import type { ConversationMessage } from "@/lib/conversationAPI";

export type ConversationStartChoice = "new" | "continue_last";
export type ConversationKind = "writing" | "speaking";

export const MIN_CONTINUATION_TUTOR_TURNS = 3;
export const DISPLAY_CONTINUATION_TUTOR_TURNS = 3;
export const RUNTIME_CONTINUATION_TUTOR_TURNS = 6;
export const CONVERSATION_START_CHOICE_STORAGE_KEY = "chicky-conversation-start-choice";

function normalizeTutorTurn(content: string): string {
  return content.trim().replace(/\s+/g, " ");
}

export function isSessionSummaryTutorMessage(content: string): boolean {
  return /^(?:#{1,6}\s*)?(?:\*\*)?session summary(?:\*\*)?\s*:/i.test(content.trim());
}

export function dedupeTutorMessages(
  messages: Pick<ConversationMessage, "role" | "content">[]
): string[] {
  const seen = new Set<string>();
  const result: string[] = [];

  for (const message of messages) {
    if (message.role !== "assistant") continue;
    if (isSessionSummaryTutorMessage(message.content)) continue;
    const content = normalizeTutorTurn(message.content);
    if (!content) continue;
    const key = content.toLocaleLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(content);
  }

  return result;
}

export function canContinueConversation(
  messages: Pick<ConversationMessage, "role" | "content">[]
): boolean {
  return dedupeTutorMessages(messages).length >= MIN_CONTINUATION_TUTOR_TURNS;
}

export function isValidContinuationLineage(
  childKind: ConversationKind,
  continuedFromConversationId: string | null,
  sourceConversationId: string
): boolean {
  return childKind === "speaking" && continuedFromConversationId === sourceConversationId;
}

export function isConversationContinuationEnabled(): boolean {
  return process.env.CONVERSATION_CONTINUATION_ENABLED !== "false";
}

export function isWebConversationContinuationEnabled(): boolean {
  return process.env.NEXT_PUBLIC_CONVERSATION_CONTINUATION_ENABLED !== "false";
}
